export default __webpack_public_path__ + "static/media/icons-ai-usage.dd1a445b.svg";